import { useCallback } from "react";
import { logDev } from "src/utils";
import { useDownloadFile } from "../useDownloadFile";

const USE_DOWNLOAD_FILE_ARGS = {
    mimetype: "text/calendar",
    filename: "appointment.ics",
    openInNewTab: false,
};

export const usePatientAppointmentICS = (): [
    React.RefObject<HTMLAnchorElement>,
    string | undefined,
    (appointmentId: number) => void,
    boolean,
] => {
    const [ref, icsFile, getFile, isLoading] = useDownloadFile(USE_DOWNLOAD_FILE_ARGS);

    const getICSFile = useCallback(
        (appointmentId: number) => {
            const route = `/shared/appointments/ics/${appointmentId}`;
            logDev("usePatientAppointmentICS.getFile - getting ICS file from route -", route);
            return getFile(route);
        },
        [getFile],
    );

    return [ref, icsFile, getICSFile, isLoading];
};
